
const _reportSettings = {};


const ReportSettings = {
  init(dataStore) {
    var self = this;

    if (_reportSettings.dataStore)
        throw new Error('ReportSettings already initialized');

    _reportSettings.dataStore = dataStore;
    _reportSettings.dataStore.isInitialized().then(function() {
        self.setVisibility();
    });
  },

  setVisibility: function() {
    var self = this;

    _reportSettings.dataStore.isInitialized().then(function() {
      _reportSettings.dataStore.raw("tabs_charts_visibility.json", function( data ) {
        try {
          var data = JSON.parse(data);
          if (data.all) {
            Object.keys(data.all).forEach(function(tabElement) {
              Object.keys(data.all[tabElement]).forEach(function(tabEltSelector) {
                data.all[tabElement][tabEltSelector].forEach(function(cssRule) {
                  $(tabEltSelector).css(cssRule);
                })
              })
            })
          }
        } catch (e) {
          if (data && data.all) {
            console.error('Fail to set chart visibility\n', e);
          }
        }
      });
    });
  }

};

Object.freeze(ReportSettings);
export default ReportSettings;



// WEBPACK FOOTER //
// ./src/modules/ReportSettings.js